export default {
  state: {
    selected: 'SignatureTemplate'
  },
  getters: {
    getTemplate: state => state
  },
  mutations: {
    SET_TEMPLATE_SELECTED (state, data) {
      state.selected = data
    }
  },
  actions: {
    async updateTemplate ({ state, commit, dispatch, rootState }, data) {
      commit('SET_TEMPLATE_SELECTED', data)
    }
  }
}
